import { useState, useEffect } from 'react'
import { Suggestion } from '../types'

// Typesense configuration
const TYPESENSE_HOST = process.env.REACT_APP_TYPESENSE_HOST
const TYPESENSE_PORT = '443'
const TYPESENSE_PROTOCOL = 'https'
const TYPESENSE_API_KEY = process.env.REACT_APP_TYPESENSE_API_KEY

interface TypesenseAnalyticsDocument {
	q: string
	count: number
}

interface TypesenseAnalyticsResponse {
	hits: Array<{
		document: TypesenseAnalyticsDocument
	}>
}

export const useAnalyticsSuggestions = (isOpen: boolean) => {
	const [suggestions, setSuggestions] = useState<Suggestion[]>([])
	const [isLoading, setIsLoading] = useState(false)

	useEffect(() => {
		if (!isOpen) {
			setSuggestions([])
			return
		}

		setIsLoading(true)

		// Fetch
		const url = `${TYPESENSE_PROTOCOL}://${TYPESENSE_HOST}:${TYPESENSE_PORT}/collections/mavbots_helix_analytics/documents/search`
		const params = new URLSearchParams({
			q: '*',
			per_page: '5'
		})

		fetch(`${url}?${params.toString()}`, {
			headers: {
				'X-TYPESENSE-API-KEY': TYPESENSE_API_KEY || '',
				'Content-Type': 'application/json'
			}
		})
			.then(async res => {
				if (!res.ok) throw new Error(`Typesense error: ${res.status}`)
				return res.json() as Promise<TypesenseAnalyticsResponse>
			})
			.then(data => {
				// Transform analytics suggestions into SearchItems
				const transformedSuggestions = data.hits.map(hit => ({
					id: `suggestion-${hit.document.q}`,
					label: hit.document.q,
					type: 'suggestion',
					section: 'Popular Searches'
				}))

				// Add group header
				const groupedSuggestions = [
					{
						id: 'group-header-suggestions',
						label: 'Popular Searches',
						type: 'GroupHeader' as any,
						isGroupHeader: true
					},
					...transformedSuggestions
				]

				setSuggestions(groupedSuggestions)
				setIsLoading(false)
			})
			.catch(err => {
				console.error('Failed to fetch analytics suggestions:', err)
				setSuggestions([])
				setIsLoading(false)
			})
	}, [isOpen])

	return {
		suggestions,
		isLoading
	}
}
